module.exports = __webpack_public_path__ + "static/media/orange.06a46467.gif";